<ng-container>
	<app-ea-spinner *ngIf="!messages"></app-ea-spinner>
	<!--TODO <my-error-component *ngIf="data.error" [error]="data.error"></my-error-component> -->
	<div *ngIf="messages">
		<div class="flex align-items-center justify-content-between pt-3 pb-2 px-4" id="header">
			<div class="pl-3 overflow-hidden">
				<span class="block text-4xl font-bold">{{ "message.page-list" | translate }}</span>
			</div>
		</div>
		<div class="col-12">
			<div class="card">
				<p-toast></p-toast>

				<p-table
					#dt
					[value]="messages"
					[(selection)]="selectedMessage"
					dataKey="id"
					styleClass="p-datatable-message"
					[rowHover]="true"
					[rows]="15"
					[paginator]="true"
					sortField="dateModification"
					[sortOrder]="-1"
					[filterDelay]="0"
					[globalFilterFields]="['titre', 'corps', 'dateModification', 'dateVisibilite', 'dateExpiration']">
					<ng-template pTemplate="caption">
						<span class="p-input-icon-left">
							<i class="pi pi-search"></i>
							<input
								pInputText
								type="text"
								(input)="dt.filterGlobal($event.target.value, 'contains')"
								placeholder="Recherche" />
						</span>
						<button
							pButton
							pRipple
							style="float: right"
							label="{{ 'message.add' | translate }}"
							icon="pi pi-message-plus"
							class="p-button-success mr-2 mb-2"
							(click)="openCreationMessagePage()"></button>
					</ng-template>
					<ng-template pTemplate="header">
						<tr>
							<th pSortableColumn="titre">
								<div class="flex justify-content-between align-items-center">
									{{ "message.titre" | translate }}
									<p-sortIcon field="titre"></p-sortIcon>
									<p-columnFilter
										type="text"
										field="titre"
										display="menu"
										class="ml-auto"></p-columnFilter>
								</div>
							</th>
							<th pSortableColumn="dateModification">
								<div class="flex justify-content-between align-items-center">
									{{ "message.dateModification" | translate }}
									<p-sortIcon field="dateModification"></p-sortIcon>
									<p-columnFilter
										type="date"
										field="dateModification"
										display="menu"
										class="ml-auto"></p-columnFilter>
								</div>
							</th>
							<th pSortableColumn="dateVisibilite">
								<div class="flex justify-content-between align-items-center">
									{{ "message.dateVisibilite" | translate }}
									<p-sortIcon field="dateVisibilite"></p-sortIcon>
									<p-columnFilter
										type="date"
										field="dateVisibilite"
										display="menu"
										class="ml-auto"></p-columnFilter>
								</div>
							</th>
							<th pSortableColumn="dateExpiration">
								<div class="flex justify-content-between align-items-center">
									{{ "message.dateExpiration" | translate }}
									<p-sortIcon field="dateExpiration"></p-sortIcon>
									<p-columnFilter
										type="date"
										field="dateExpiration"
										display="menu"
										class="ml-auto"></p-columnFilter>
								</div>
							</th>
							<th pSortableColumn="destinatairesCount">
								<div class="flex justify-content-between align-items-center">
									{{ "message.destinataires-count" | translate }}
									<p-sortIcon field="destinatairesCount"></p-sortIcon>
									<p-columnFilter
										type="integer"
										field="destinatairesCount"
										display="menu"
										class="ml-auto"></p-columnFilter>
								</div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-message let-rowIndex="rowIndex">
						<tr class="p-selectable-row" (click)="onSelection(message)">
							<td>
								{{ message.titre | slice : 0 : 20 }}
							</td>
							<td>
								{{ message.dateModification | date : "longDate" }}
							</td>
							<td>
								{{ message.dateVisibilite | date : "longDate" }}
							</td>
							<td>
								{{ message.dateExpiration | date : "longDate" }}
							</td>
							<td>
								{{ message.destinataires.length }}
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="8">{{ "message.list-empty" | translate }}</td>
						</tr>
					</ng-template>
				</p-table>
				<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
				<app-message-modal
					[messageId]="selectedMessageId"
					(updateList)="updateMessages()"
					(closeModal)="restartSelection()"></app-message-modal>
			</div>
		</div>
	</div>
</ng-container>
